import React, { Component } from "react";
import { Button, Col, Form, Modal, Row, Tab, Tabs } from "react-bootstrap";

import { connect } from "react-redux";
import _ from "lodash";
import Sidebar from "../common/sidebar";
import Pagination from "react-js-pagination";
import { Link } from "react-router-dom";
import moment from "moment-timezone";
import { reportsActions } from "../../_actions";
import { UserIcon } from "../Svg";
import Loader from "../../components/common/Loader";
import "./imageModal.css";

class ReportList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      orderInfo: [],
      ItemList: [],
      reId: [],
      excelFile: "",
      examDate: "",
      ItemId: [],
      itemId: [],
      inventoryType: 1,
      sortField: "",
      sortType: 1,

      reasonErMsg: "",
      show: false,
      farmName: "",
      addExamPopup: false,
      messagePopup: 0,
      alertPopup: 0,
      emailPopup: 0,
      lat: 0,
      long: "",
      count: 10,
      totalCount: 0,
      userListCount: 0,
      dataCount: 0,
      filterHarvest: "",
      pageNo: 1,
      orderInfo1: [],
      userStatus: 0,
      profilePicPreview: "",

      examName: "",
      userId: "",
      deletePopup: false,
      examNameErrorMsg: "",
      examDateErrorMsg: "",
      reportedUsers: [],
      reportedUsersCount: 0,
      reportedDishes: [],
      reportedDishesCount: 0,
      totalReports: 0,
      // userId: localStorage.getItem('userId'),
      profilePicErrorMsg: "",
      loader: true,
      showImageModal: false,
      imageModalSrc: "",
      imageModalAlt: "",
      showConfirmModal: false,
      confirmModalAction: null,
      selectedDishId: null,
      confirmModalTitle: "",
      confirmModalMessage: "",
    };
  }

  componentDidMount() {
    this.initializeReports();
  }

  initializeReports = () => {
    this.setState({ errors: "", loader: true }, () => {
      Promise.all([this.fetchReportedUsers(), this.fetchReportedDishes()])
        .catch(() => {})
        .finally(() => {
          this.setState({ loader: false });
        });
    });
  };

  buildQueryParams = () => {
    const { pageNo, count, sortField, sortType, search } = this.state;
    const sortFieldParam = sortField ? sortField : "";
    const sortTypeParam = sortField && sortType && sortType !== 1 ? sortType : "";
    const trimmedSearch = search ? search.trim() : "";
    return `?pageNo=${pageNo}&count=${count}&sortField=${sortFieldParam}${sortTypeParam ? `&sortType=${sortTypeParam}` : ""}&search=${trimmedSearch}`;
  };

  fetchReportedUsers = () => {
    const { dispatch } = this.props;
    const params = this.buildQueryParams();

    return dispatch(reportsActions.getReportedUsers(params))
      .then((data) => {
        const responseData = data.responseData || {};
        const reportList =
          responseData.reportList || responseData.reportedUserList || [];
        const reportListCount =
          responseData.reportListCount ||
          responseData.reportedUserListCount ||
          responseData.totalCount ||
          reportList.length ||
          0;

        if (data.statusCode == 1) {
          this.setState((prevState) => ({
            reportedUsers: reportList,
            reportedUsersCount: reportListCount,
            totalReports: reportListCount + prevState.reportedDishesCount,
            errors: "",
          }));
        } else {
          this.setState({
            errors: data.error ? data.error.responseMessage : "",
          });
        }

        return data;
      })
      .catch((err) => {
        this.setState({
          errors:
            (err && err.response && err.response.data
              ? err.response.data.responseMessage
              : "Something went wrong") || "",
        });
        throw err;
      });
  };

  fetchReportedDishes = () => {
    const { dispatch } = this.props;
    const params = this.buildQueryParams();

    return dispatch(reportsActions.getReportedDishes(params))
      .then((data) => {
        const responseData = data.responseData || {};
        const reportList =
          responseData.reportList || responseData.reportedDishList || [];
        const reportListCount =
          responseData.reportListCount ||
          responseData.reportedDishListCount ||
          responseData.totalCount ||
          reportList.length ||
          0;

        if (data.statusCode == 1) {
          this.setState((prevState) => ({
            reportedDishes: reportList,
            reportedDishesCount: reportListCount,
            totalReports: prevState.reportedUsersCount + reportListCount,
            errors: "",
          }));
        } else {
          this.setState({
            errors: data.error ? data.error.responseMessage : "",
          });
        }

        return data;
      })
      .catch((err) => {
        this.setState({
          errors:
            (err && err.response && err.response.data
              ? err.response.data.responseMessage
              : "Something went wrong") || "",
        });
        throw err;
      });
  };

  loadActiveTabData = () => {
    const { inventoryType } = this.state;
    if (inventoryType == 1) {
      return this.fetchReportedUsers();
    }
    return this.fetchReportedDishes();
  };
  handlePageChange = (pageNo) => {
    var self = this;
    this.setState({ loader: true, pageNo: pageNo, count: 10 }, () => {
      self
        .loadActiveTabData()
        .finally(() => self.setState({ loader: false }));
    });
  };
  handleChanged = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      // emailError: ''
    });
  };

  handleFilter = (ele) => {
    this.setState(
      {
        loader: false,
        reasonErMsg: "",
        filterHarvest: ele,
        count: 10,
        pageNo: 1,
      },
      () => this.getOrderList()
    );
  };

  handleClose = () => {
    this.setState({
      addExamPopup: false,
      deletePopup: false,
      showInvoice: false,
    });
  };

  ConvertDate = (created) => {
    if (!created) {
      return "-";
    }

    const dateValue = moment(created);

    if (!dateValue.isValid()) {
      return "-";
    }

    return dateValue.format("MM/DD/YYYY");
  };
  ConvertDob = (dob) => {
    // let data =        Date(dob)
    let data = moment(dob).format("MM/DD/YYYY");
    return data;
  };

  handleShowAddExam = (item) => {
    this.setState({ addExamPopup: true, ItemList: item });
  };

  handleValidate = () => {
    let validate = true;
    if (this.state.examDate === "" || this.state.examDate === undefined) {
      validate = false;
      this.setState({
        examDateErrorMsg: "Please enter exam date.",
      });
    } else {
      this.setState({
        examDateErrorMsg: "",
      });
    }
    if (this.state.examName === "" || this.state.examName === undefined) {
      validate = false;
      this.setState({
        examNameErrorMsg: "Please enter exam name.",
      });
    } else {
      this.setState({
        examNameErrorMsg: "",
      });
    }

    return validate;
  };

  openImageModal = (src, alt) => {
    this.setState({
      showImageModal: true,
      imageModalSrc: src,
      imageModalAlt: alt || "Image preview",
    });
  };

  closeImageModal = () => {
    this.setState({
      showImageModal: false,
      imageModalSrc: "",
      imageModalAlt: "",
    });
  };

  openConfirmModal = (dishId, action) => {
    const isApprove = action === "approve";
    this.setState({
      showConfirmModal: true,
      confirmModalAction: action,
      selectedDishId: dishId,
      confirmModalTitle: isApprove ? "Approve Dish" : "Reject Dish",
      confirmModalMessage: isApprove
        ? "Are you sure you want to approve this dish report? This action cannot be undone."
        : "Are you sure you want to reject this dish report? This action cannot be undone.",
    });
  };

  closeConfirmModal = () => {
    this.setState({
      showConfirmModal: false,
      confirmModalAction: null,
      selectedDishId: null,
      confirmModalTitle: "",
      confirmModalMessage: "",
    });
  };

  handleConfirmAction = () => {
    const { confirmModalAction, selectedDishId } = this.state;
    const { dispatch } = this.props;

    if (!selectedDishId) return;

    const params = { dishId: selectedDishId };

    this.setState({ loader: true }, () => {
      const action = confirmModalAction === "approve" 
        ? reportsActions.acceptReportedDish(params)
        : reportsActions.rejectReportedDish(params);

      dispatch(action)
        .then((data) => {
          if (data.statusCode == 1) {
            this.closeConfirmModal();
            this.fetchReportedDishes().finally(() => {
              this.setState({ loader: false });
            });
          } else {
            this.setState({
              errors: data.error ? data.error.responseMessage : "Action failed",
              loader: false,
            });
          }
        })
        .catch((err) => {
          this.setState({
            errors:
              (err && err.response && err.response.data
                ? err.response.data.responseMessage
                : "Something went wrong") || "",
            loader: false,
          });
        });
    });
  };

  handleMaltiSelct = (e, val) => {
    let { orderInfo, multiValue } = this.state;
    let self = this;
    this.setState({ reasonErMsg: "" });
    multiValue =
      typeof this.state.multiValue === "object" ? this.state.multiValue : [];
    let reIdval = [];

    if (this.state.reId.includes(val)) {
      for (var i = 0; i < this.state.reId.length; i++) {
        if (this.state.reId[i] === val) {
          this.state.reId.splice(i, 1);
        }
      }
    } else {
      this.state.reId.push(val);
    }

    this.state.orderInfo.map(function (value, index) {
      if (value._id == val) {
        orderInfo[index].status = orderInfo[index].status === 2 ? 3 : 2;

        if (orderInfo[index].status == 2) {
          multiValue.push(value._id);
        } else if (orderInfo[index].status == 3) {
          multiValue.splice(value._id);
        }
      }
    });

    this.setState({ multiValue }, () => {});
  };
  handleShow = (item) => {
    this.setState({ deletePopup: true, userId: item._id, userStatus: 3 });
  };
  sendToParent = (e) => {
    this.setState({ loader: true }, () => {
      this.loadActiveTabData().finally(() => this.setState({ loader: false }));
    });
  };

  changeName = (event) => {
    const self = this;
    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      search: event.target.value.trim(),
      typing: false,
      typingTimeout: setTimeout(function () {
        self.sendToParent(self.state.name);
      }, 1000),
    });
  };

  inventoryType = (e) => {
    const tabKey = parseInt(e, 10);
    if (tabKey === 1 || tabKey === 2) {
      this.setState({ inventoryType: tabKey, pageNo: 1, loader: true }, () => {
        this.loadActiveTabData().finally(() =>
          this.setState({ loader: false })
        );
      });
    }
  };
  handleSort = (sortField) =>
    this.setState(
      {
        loader: true,
        sortField,
        sortType: this.state.sortType === 1 ? -1 : 1,
      },
      () => {
        this.loadActiveTabData().finally(() =>
          this.setState({ loader: false })
        );
      }
    );

  render() {
    let {
      inventoryType,
      deletePopup,
      reportedUsers,
      reportedUsersCount,
      reportedDishes,
      reportedDishesCount,
      totalReports,
      errors,
      examDateErrorMsg,
      examDate,
      examName,
      examNameErrorMsg,
      profilePicErrorMsg,
      excelFile,
      filterHarvest,
      farmName,
      reasonErMsg,
      orderInfo,
      count,
      pageNo,
      totalCount,
      dataCount,
      ItemList,
      profilePicPreview,
      showImageModal,
      imageModalSrc,
      imageModalAlt,
      showConfirmModal,
      confirmModalTitle,
      confirmModalMessage,
    } = this.state;

    const formatUserName = (user = {}) => {
      const firstLast = `${user.firstName || ""} ${user.lastName || ""}`.trim();
      return firstLast || user.fullName || user.userName || user.email || "";
    };

    const renderUserLink = (user) => {
      if (!user) {
        return "-";
      }

      const displayName = formatUserName(user) || "-";

      if (user._id) {
        return <Link to={`user-info/${user._id}`}>{displayName}</Link>;
      }

      return displayName;
    };

    const resolveCreatedOn = (item) =>
      (item && (item.createdAt)) || "";

    return (
      <>
        <Sidebar />
        <div className="body_container">
          <div className="header_search header_search_custom ">
            <div className="row mb-3 mx-0">
              <div className="col-md-7">
                <div className="row mb-3 gap-4 gap-md-0">
                  <div className="col-md-4 px-4">
                    <div className="count-list">
                      <div>
                        <div>
                          <span className="user-icon icon-grey m-lr-auto">
                            <i
                              className="fa fa-users sizeCircle"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mt-4">
                          <h6 className="mb-0 mr-2">Reported Users </h6>
                          <h6 className="mb-0">{reportedUsersCount || 0}</h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4 px-4">
                    <div className="count-list">
                      <div>
                        <div>
                          <span className="user-icon icon-grey m-lr-auto">
                            <i
                              className="fa fa-exclamation-circle sizeCircle"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mt-4">
                          <h6 className="mb-0">Reported Dishes</h6>
                          <h6 className="mb-0">{reportedDishesCount || 0}</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3 ml-auto px-0">
                <div className="form-group has-search">
                  <span className="fa fa-search form-control-feedback max-md-hidden"></span>
                  {/*<Form.Control type="Search" placeholder="Search..." name="search" value={"search"}></Form.Control>*/}
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    name={"search"}
                    onChange={this.changeName}
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="body_inner_wrapper">
              {this.state.loader ? (
                <Loader />
              ) : (
                <>
                  <header className="header_content">
                    <p>Reports</p>
                  </header>

                  <div className="main_content">
                    <div className="cm-inventory">
                      <Tabs
                        defaultActiveKey="1"
                        onSelect={(e) => this.inventoryType(e)}
                        activeKey={String(inventoryType)}
                        id="uncontrolled-tab-example"
                      >
                        <Tab eventKey="1" title="Reported Users">
                          <div className="cm-inventory_gridview">
                            <div className="table-responsive">
                              <table className="table cm_bottom_space">
                                <thead>
                                  <tr className="broder_top_0">
                                    <th scope="col" className="ws-nowrap">
                                      S. No.
                                    </th>
                                    <th
                                      scope="col"
                                      onClick={() => this.handleSort("created")}
                                    >
                                      Created On
                                      <i className="fas fa-sort text_dark ml-2 d-inline-block"></i>
                                    </th>
                                    <th
                                      scope="col"
                                      onClick={() =>
                                        this.handleSort("firstName")
                                      }
                                    >
                                      Reported To{" "}
                                      <i className="fas fa-sort text_dark ml-2 d-inline-block"></i>
                                    </th>
                                    <th
                                      scope="col"
                                      onClick={() =>
                                        this.handleSort("firstName")
                                      }
                                    >
                                      Reported By
                                      <i className="fas fa-sort text_dark ml-2 d-inline-block"></i>
                                    </th>
                                    <th scope="col">
                                      Reason
                                    </th>
                                    <th scope="col" className="ws-nowrap">
                                      Evidence
                                    </th>

                                    {/*<th scope="col" className="ws-nowrap">Profic pic</th>   */}
                                    {/* <th scope="col" className="ws-nowrap">
                                      Status
                                    </th>
                                    <th scope="col" className="ws-nowrap">
                                      Claimed Status
                                    </th> */}
                                  </tr>
                                </thead>
                                <tbody>
                                  {!_.isEmpty(reportedUsers) &&
                                    reportedUsers.map((item, i) => {
                                      const reportedToUser =
                                        item.reportedToUser 

                                      const reportedByUser =
                                        item.reportedByUser 

                                      const evidencePreview =
                                        item &&
                                        item.evidenceFiles &&
                                        item.evidenceFiles.length
                                          ? item.evidenceFiles[0]
                                          : "";

                                      // const statusText =
                                      //   reportedByUser &&
                                      //   typeof reportedByUser.userStatus !==
                                      //     "undefined"
                                      //     ? reportedByUser.userStatus === 1
                                      //       ? "Active"
                                      //       : "Inactive"
                                      //     : "-";

                                      // const claimedStatusText =
                                      //   reportedByUser &&
                                      //   typeof reportedByUser.claimedStatus !==
                                      //     "undefined"
                                      //     ? reportedByUser.claimedStatus === 1
                                      //       ? "claimed"
                                      //       : "unclaimed"
                                      //     : "-";

                                      return (
                                        <tr key={item._id || i}>
                                          <td>
                                            {count * (pageNo - 1) + (i + 1)}
                                          </td>
                                          <td>
                                            {this.ConvertDate(
                                              resolveCreatedOn(item)
                                            )}
                                          </td>
                                          <td>
                                            {renderUserLink(reportedToUser)}
                                          </td>
                                          <td>
                                            {renderUserLink(reportedByUser)}
                                          </td>
                                          <td>
                                            {item?.reason ? item.reason : "-"}
                                          </td>
                                          <td className="table-image-cell">
                                            {evidencePreview ? (
                                              <button
                                                type="button"
                                                className="btn btn-link p-0 border-0 table-image-button"
                                                aria-label="View evidence"
                                                onClick={() =>
                                                  this.openImageModal(
                                                    evidencePreview,
                                                    `${formatUserName(
                                                      reportedByUser
                                                    )} evidence`
                                                  )
                                                }
                                              >
                                                <img
                                                  height="40"
                                                  width="40"
                                                  alt="Evidence"
                                                  src={evidencePreview}
                                                  className="object-fit-contain"
                                                />
                                              </button>
                                            ) : (
                                              "-"
                                            )}
                                          </td>
                                          {/* <td>{statusText}</td>
                                          <td className="capitalize">
                                            {claimedStatusText}
                                          </td> */}
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              </table>
                              {reportedUsersCount > 0 ? (
                                <div className="d-flex justify-content-end cm-pagination">
                                  <Pagination
                                    itemClassPrev={"prevClass"}
                                    itemClassNext={"nextClass"}
                                    activePage={this.state.pageNo}
                                    itemsCountPerPage={this.state.count}
                                    totalItemsCount={reportedUsersCount}
                                    pageRangeDisplayed={3}
                                    onChange={this.handlePageChange}
                                  />
                                </div>
                              ) : (
                                ""
                              )}
                              {_.isEmpty(reportedUsers) ? (
                                <h3 className="text-center">No data found</h3>
                              ) : (
                                ""
                              )}
                              {reasonErMsg ? (
                                <div className="text-center error ">
                                  {reasonErMsg}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </Tab>

                        <Tab eventKey="2" title="Reported Dishes">
                          <div className="cm-inventory_gridview">
                            <div className="table-responsive">
                              <table className="table cm_bottom_space">
                                <thead>
                                  <tr className="broder_top_0">
                                    <th scope="col" className="ws-nowrap">
                                      S. No.
                                    </th>
                                    <th
                                      scope="col"
                                      onClick={() => this.handleSort("created")}
                                    >
                                      Created On
                                      <i className="fas fa-sort text_dark ml-2 d-inline-block"></i>
                                    </th>
                                    <th scope="col" className="ws-nowrap">
                                      Dish From
                                    </th>
                                    <th scope="col" className="ws-nowrap">
                                      Dish To
                                    </th>
                                    <th scope="col" className="ws-nowrap">
                                      Reported By
                                    </th>
                                    <th scope="col">Reason</th>
                                    <th scope="col" className="ws-nowrap">
                                      Evidence
                                    </th>
                                    <th scope="col" className="ws-nowrap">
                                      Approve / Reject
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {!_.isEmpty(reportedDishes) &&
                                    reportedDishes.map((item, i) => {
                                      const dishFromUser = item.dishFromUser;
                                      const dishToUser = item.dishToUser;
                                      const reportedByUser =
                                        item.reportedByUser;

                                      const evidencePreview =
                                        item &&
                                        item.reportResponse &&
                                        item.reportResponse.responseImageUrl
                                          ? item.reportResponse.responseImageUrl
                                          : "";

                                      const hasResponded = item?.reportResponse?.hasResponded === true;

                                      return (
                                        <tr key={item._id || i}>
                                          <td>
                                            {count * (pageNo - 1) + (i + 1)}
                                          </td>
                                          <td>
                                            {this.ConvertDate(
                                              resolveCreatedOn(item)
                                            )}
                                          </td>
                                          <td>
                                            {renderUserLink(dishFromUser)}
                                          </td>
                                          <td>{renderUserLink(dishToUser)}</td>
                                          <td>
                                            {renderUserLink(reportedByUser)}
                                          </td>
                                          <td>
                                            {item?.reportResponse?.responseText
                                              ? item.reportResponse.responseText
                                              : "-"}
                                          </td>
                                          <td className="table-image-cell">
                                            {evidencePreview ? (
                                              <button
                                                type="button"
                                                className="btn btn-link p-0 border-0 table-image-button"
                                                aria-label="View evidence"
                                                onClick={() =>
                                                  this.openImageModal(
                                                    evidencePreview,
                                                    `${formatUserName(
                                                      reportedByUser
                                                    )} evidence`
                                                  )
                                                }
                                              >
                                                <img
                                                  height="40"
                                                  width="40"
                                                  alt="Evidence"
                                                  src={evidencePreview}
                                                  className="object-fit-contain"
                                                />
                                              </button>
                                            ) : (
                                              "-"
                                            )}
                                          </td>
                                          <td
                                            style={
                                              item.adminDecision &&
                                              item.adminDecision !== "pending"
                                                ? { cursor: "default" }
                                                : {
                                                    paddingTop: "8px",
                                                    paddingBottom: "8px",
                                                  }
                                            }
                                          >
                                            {item.adminDecision &&
                                            item.adminDecision !== "pending" ? (
                                              <span
                                                className={
                                                  item.adminDecision ===
                                                  "accepted"
                                                    ? "text-success font-weight-bold"
                                                    : item.adminDecision ===
                                                      "rejected"
                                                    ? "text-danger font-weight-bold"
                                                    : ""
                                                }
                                              >
                                                {item.adminDecision ===
                                                "accepted"
                                                  ? "Approved"
                                                  : item.adminDecision ===
                                                    "rejected"
                                                  ? "Rejected"
                                                  : item.adminDecision}
                                              </span>
                                            ) : (
                                              <div
                                                className="d-flex"
                                                style={{
                                                  maxWidth: "100px",
                                                  gap: "10px",
                                                }}
                                              >
                                                <div
                                                  title={
                                                    hasResponded
                                                      ? "Approve"
                                                      : "Approve (Waiting for Evidence/Reason)"
                                                  }
                                                  style={{
                                                    display: "inline-block",
                                                    cursor: hasResponded
                                                      ? "pointer"
                                                      : "not-allowed",
                                                  }}
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0 border-0"
                                                    aria-label="Approve dish"
                                                    onClick={() =>
                                                      hasResponded &&
                                                      this.openConfirmModal(
                                                        item._id,
                                                        "approve"
                                                      )
                                                    }
                                                    disabled={!hasResponded}
                                                    style={{
                                                      opacity: hasResponded
                                                        ? 1
                                                        : 0.5,
                                                    }}
                                                  >
                                                    <i
                                                      className="fas fa-check-circle text-success"
                                                      style={{
                                                        fontSize: "20px",
                                                      }}
                                                    ></i>
                                                  </button>
                                                </div>
                                                <div
                                                  title={
                                                    hasResponded
                                                      ? "Reject"
                                                      : "Reject (Waiting for Evidence/Reason)"
                                                  }
                                                  style={{
                                                    display: "inline-block",
                                                    cursor: hasResponded
                                                      ? "pointer"
                                                      : "not-allowed",
                                                  }}
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0 border-0"
                                                    aria-label="Reject dish"
                                                    onClick={() =>
                                                      hasResponded &&
                                                      this.openConfirmModal(
                                                        item._id,
                                                        "reject"
                                                      )
                                                    }
                                                    disabled={!hasResponded}
                                                    style={{
                                                      opacity: hasResponded
                                                        ? 1
                                                        : 0.5,
                                                    }}
                                                  >
                                                    <i
                                                      className="fas fa-times-circle text-danger"
                                                      style={{
                                                        fontSize: "20px",
                                                      }}
                                                    ></i>
                                                  </button>
                                                </div>
                                              </div>
                                            )}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              </table>
                              {reportedDishesCount > 0 ? (
                                <div className="d-flex justify-content-end cm-pagination">
                                  <Pagination
                                    itemClassPrev={"prevClass"}
                                    itemClassNext={"nextClass"}
                                    activePage={this.state.pageNo}
                                    itemsCountPerPage={this.state.count}
                                    totalItemsCount={reportedDishesCount}
                                    pageRangeDisplayed={3}
                                    onChange={this.handlePageChange}
                                  />
                                </div>
                              ) : (
                                ""
                              )}
                              {_.isEmpty(reportedDishes) ? (
                                <h3 className="text-center">No data found</h3>
                              ) : (
                                ""
                              )}
                              {reasonErMsg ? (
                                <div className="text-center error ">
                                  {reasonErMsg}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </Tab>
                      </Tabs>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <Modal
            show={showImageModal}
            onHide={this.closeImageModal}
            centered
            size="lg"
            dialogClassName="profile-image-modal"
          >
            <Modal.Header closeButton>
              <Modal.Title>Image Preview</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center profile-image-modal__body">
              {imageModalSrc ? (
                <img
                  src={imageModalSrc}
                  alt={imageModalAlt || "Image preview"}
                  className="img-fluid object-fit-contain"
                />
              ) : (
                <span>-</span>
              )}
            </Modal.Body>
          </Modal>
          <Modal
            aria-labelledby="example-modal-sizes-title-sm "
            show={this.state.addExamPopup}
            onHide={this.handleClose}
            className="cm_order_view order-detailsmodal"
          >
            <Modal.Header closeButton>
              <Modal.Title id="example-modal-sizes-title-sm">
                <h6>Add Exam</h6>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <form onSubmit={this.handlAddExam}>
                  <Row>
                    <Col md="3">
                      <p>Exam Name:</p>
                    </Col>
                    <Col md="9">
                      <Form.Control
                        type="text"
                        onChange={this.handleChanged}
                        name="examName"
                        value={examName}
                        placeholder="Exam Name"
                      />
                      {examNameErrorMsg ? (
                        <div className="error">{examNameErrorMsg}</div>
                      ) : null}
                    </Col>
                  </Row>

                  <Row>
                    <Col md="3">
                      <p>Exam Date:</p>
                    </Col>
                    <Col md="9">
                      <Form.Control
                        type="text"
                        onChange={this.handleChanged}
                        name="examDate"
                        value={examDate}
                        placeholder="Exam Date "
                      />
                      {examDateErrorMsg ? (
                        <div className="error">{examDateErrorMsg}</div>
                      ) : null}
                    </Col>
                  </Row>

                  {errors ? errors : ""}
                  <Row>
                    <Col md="10" className="text-sm-right">
                      <Button type="submit" variant="warning" className="mr-2">
                        Save
                      </Button>
                      &nbsp;
                      <Button onClick={this.viewMode} variant="dark">
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </form>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div className="footer_btn_wrapper">
                {/*<Button variant="warning" className="text-light"*/}
                {/*        onClick={() => this.handleItemAction(ItemList._id, 2)}*/}
                {/*>*/}
                {/*    ExamList Fulfilled*/}
                {/*</Button>*/}
              </div>
              <div className="print_button orderabs">
                {/*<Button onClick={()=>this.redirect(ItemList)} variant="light"><i*/}
                {/*    className="fas fa-print"></i> Print </Button>*/}

                <Link className="btn btn-light ">
                  <i className="fas fa-print" title="Invoicddddde"></i>Print
                </Link>
              </div>
            </Modal.Footer>
          </Modal>

          <Modal
            show={deletePopup}
            onHide={this.handleClose}
            className="cm_order_view dlt_item"
          >
            <Modal.Header closeButton>
              <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to delete this user?</p>
            </Modal.Body>
            <Modal.Footer>
              <div className="footer_btn_wrapper">
                <Button variant="warning" onClick={(e) => this.handleDelete()}>
                  Delete
                </Button>
                {/*<span><i onClick={(e)=>this.handleDelete(e,item)} className="fas fa-trash-alt"></i></span>*/}

                <Button variant="dark" onClick={this.handleClose}>
                  Cancel
                </Button>
              </div>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showConfirmModal}
            onHide={this.closeConfirmModal}
            centered
            className="cm_order_view dlt_item"
          >
            <Modal.Header closeButton>
              <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>{confirmModalMessage}</p>
            </Modal.Body>
            <Modal.Footer>
              <div className="footer_btn_wrapper button_space">
                <Button
                  variant={this.state.confirmModalAction === "approve" ? "success" : "danger"}
                  onClick={this.handleConfirmAction}
                  onMouseEnter={(e) => {
                    const btn = e.currentTarget;
                    if (this.state.confirmModalAction === "approve") {
                      btn.style.backgroundColor = '#218838';
                      btn.style.borderColor = '#1e7e34';
                    } else {
                      btn.style.backgroundColor = '#c82333';
                      btn.style.borderColor = '#bd2130';
                    }
                  }}
                  onMouseLeave={(e) => {
                    const btn = e.currentTarget;
                    if (this.state.confirmModalAction === "approve") {
                      btn.style.backgroundColor = '#28a745';
                      btn.style.borderColor = '#28a745';
                    } else {
                      btn.style.backgroundColor = '#dc3545';
                      btn.style.borderColor = '#dc3545';
                    }
                  }}
                >
                  {this.state.confirmModalAction === "approve" ? "Approve" : "Reject"}
                </Button>
                <Button variant="dark" onClick={this.closeConfirmModal}>
                  Cancel
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        </div>
      </>
    );
  }
}

// export default

function mapStateToProps(state) {
  const { props, login, user, mapReducer } = state;
  return {
    props,
    login,
    user,
    mapReducer,
  };
}

export default connect(mapStateToProps)(ReportList);
// export default Settings
